import React from 'react';

const TradeInInfoEquipment = ({tradeInInfoEquipment}) => {
  // Render table headers outside the map function
  const renderTableHeaders = () => (
    <div className='table-row'>
      <div className='table-cell'>
        <span className='table-header'>ציוד שנרכש</span>
      </div>
      <div className='table-cell'>
        <span className='table-header'>ציוד שהוחזר</span>
      </div>
      <div className='table-cell'>
        <span className='table-header'>החזר מקסימלי</span>
      </div>
    </div>
  );

  return (
    <>
      {renderTableHeaders()}
      {tradeInInfoEquipment?.map((equipment, idx) => (
        <div key={idx.toString() + equipment.name} className='table-row'>
          <div className='table-cell'>
            <span className='table-cell-info'>{equipment.purchasedEquipmentDesc}</span>
          </div>
          <div className='table-cell'>
            <span className='table-cell-info'>{equipment.returendEquipmentDesc}</span>
          </div>
          <div className='table-cell'>
            <span className='table-cell-info'>
              {equipment.maxPrice !== '' && equipment.maxPrice !== null ? equipment.maxPrice : 0} &#8362;
            </span>
          </div>
        </div>
      ))}
    </>
  );
};

export default TradeInInfoEquipment;
